<template>
  <div class="home">
    <Header>My memos</Header>
    <ul v-for="memo in newest" :key="memo.id">
      <li>
        <router-link :to="{ name: 'Edit', params: { id: memo.id } }">
          {{ memo.body }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<style>
body {
  font-family: "Montserrat", sans-serif;
  background: #ebecf0;
  padding: 0.5em;
  font-size: 1.3em;
  text-align: center;
}
a {
  color: #red;
  text-decoration: none;
}
a:link {
  color: #6495ed;
}
a:visited {
  color: #778899;
}
li {
  list-style: none;
}
textarea {
  border-radius: 40px;
  width: 90%;
  height: 3em;
  margin: 0 auto;
  background-color: #ebecf0;
  border: 1px solid #d3d3d3;
  box-shadow: inset 2px 2px 10px #c8c9cc, inset -2px -2px 10px #ffffff;
  line-height: 0;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: 0 30px;
  font-size: 1em;
}
textarea:focus {
  border-color: #b0c4de;
  background-color: #ebecf0;
  outline: none;
}
button {
  padding: 10px 20px;
  margin-top: 10px;
  border: 0;
  outline: 0;
  font-size: 0.8em;
  border-radius: 205px;
  padding: $ruler;
  background-color: #ebecf0;
  text-shadow: 1px 1px 0 #fff;
  box-shadow: 5px 5px 20px #bec3c9, -5px -5px 20px #ffffff;
}
button:hover {
  box-shadow: -2px -2px 5px $color-white, 2px 2px 5px $color-shadow;
}
button:active {
  box-shadow: inset 1px 1px 2px $color-shadow, inset -1px -1px 2px $color-white;
}
</style>

<script>
import Header from "@/components/Header.vue";

export default {
  name: "HOME",
  components: {
    Header,
  },
  computed: {
    newest: function() {
      return this.$store.state.memos.slice().reverse();
    },
  },
};
</script>
